import { motion, useReducedMotion } from 'motion/react'

interface PhaseIndicatorProps {
  currentPhase: number   // 0-5 (active phase index)
  completedPhases: number[]
}

export function PhaseIndicator({ currentPhase, completedPhases }: PhaseIndicatorProps) {
  const reducedMotion = useReducedMotion()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 'var(--spacing-3)',
        justifyContent: 'center',
      }}
      role="status"
      aria-label={`Processing phase ${currentPhase + 1} of 6`}
    >
      {Array.from({ length: 6 }, (_, i) => {
        const isCompleted = completedPhases.includes(i)
        const isActive = i === currentPhase && !isCompleted

        return (
          <motion.span
            key={i}
            style={{
              display: 'inline-block',
              width: '8px',
              height: '8px',
              borderRadius: 'var(--radius-full)',
              flexShrink: 0,
              backgroundColor: isCompleted || isActive
                ? 'var(--color-action-primary)'
                : 'var(--stepper-node-upcoming)',
              opacity: isCompleted || isActive ? 1 : 0.4,
              transform: isCompleted ? 'scale(0.85)' : 'scale(1)',
            }}
            initial={false}
            animate={
              reducedMotion
                ? {}
                : isActive
                  ? {
                      boxShadow: [
                        '0 0 0 2px rgba(2, 93, 224,0.1)',
                        '0 0 0 8px rgba(2, 93, 224,0.3)',
                        '0 0 0 2px rgba(2, 93, 224,0.1)',
                      ],
                      opacity: 1,
                      scale: 1,
                    }
                  : isCompleted
                    ? { boxShadow: 'none', opacity: 1, scale: 0.85 }
                    : { boxShadow: 'none', opacity: 0.4, scale: 1 }
            }
            transition={
              reducedMotion
                ? { duration: 0 }
                : isActive
                  ? { duration: 1.6, repeat: Infinity, ease: 'easeInOut' }
                  : { duration: 0.2, ease: 'easeOut' }
            }
          />
        )
      })}
    </div>
  )
}
